import { MarketingCaseSnapshot } from '@/components/Approval/@components/MarketingCase';
import { parseMarketingCaseAttributes } from '@/utils/approval/marketingCase';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 83 (구)마케팅 건별 진행 — 저장 content 그대로, 「상세보기」도 작성 시점 견적 상세 */
const MarketingCaseSlot = ({ data }: ContentExtraProps) => {
  const content = parseMarketingCaseAttributes(data.attributes)?.content;
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <MarketingCaseSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default MarketingCaseSlot;
